export default [
  {
    path: "/service-machines",
    name: "service-machines",
    component: () => import("@/modules/service-machines/ServiceMachines.vue"),
    children: [
      {
        path: "list",
        name: "list-service-machines",
        component: () =>
          import("@/modules/service-machines/pages/ServiceMachinesList.vue"),
        meta: { permissions: ["service-show"] }
      },
      {
        path: "edit/:id",
        name: "edit-service-machines",
        component: () =>
          import("@/modules/service-machines/pages/ServiceMachinesEdit.vue"),
        meta: { permissions: ["service-update"] }
      }
    ]
  }
];
